import { Link } from "react-router-dom"
import { COVERAGE } from "../site/coverage"
import { NlSection } from "./NlSection"

const SRC_LABEL: Record<string, string> = {
  sc: "Supreme Court judgments", hc: "High Court orders", cestat: "CESTAT orders", aar: "Advance rulings",
}

/** The landing page's teaser strip: the counts for the first four sources (the strip is four columns wide), and a link to the coverage page (/coverage), which lists them all. */
export function InsideTeaser() {
  return (
    <NlSection id="inside" eyebrow={"What’s inside Nira"} title="Everything Nira reads before it answers.">
      <div className="nl-teaser">
        <div className="nl-teaser-row">
          {COVERAGE.sources.slice(0, 4).map((r) => (
            <div key={r.key}><b>{r.approx}</b><span>{SRC_LABEL[r.key] ?? r.name}</span></div>
          ))}
        </div>
        <Link className="nl-link" to="/coverage">See everything Nira has read, and what is coming</Link>
      </div>
    </NlSection>
  )
}
